import React from 'react';

import BaseFilterChip from './BaseFilterChip';

type Props = {
  value?: string | null;
  onDelete: () => void;
};
export default function BatchFilterChip({ value, onDelete }: Props) {
  if (!value) {
    return null;
  }
  return <BaseFilterChip label={`Batch: ${value}`} onDelete={onDelete} />;
}
